var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgChevronDownDisabled = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.29279 9.29357C7.48031 9.1061 7.73462 9.00078 7.99979 9.00078C8.26495 9.00078 8.51926 9.1061 8.70679 9.29357L11.9998 12.5866L15.2928 9.29357C15.385 9.19806 15.4954 9.12188 15.6174 9.06947C15.7394 9.01706 15.8706 8.98947 16.0034 8.98832C16.1362 8.98717 16.2678 9.01247 16.3907 9.06275C16.5136 9.11303 16.6253 9.18728 16.7192 9.28117C16.8131 9.37507 16.8873 9.48672 16.9376 9.60962C16.9879 9.73251 17.0132 9.86419 17.012 9.99697C17.0109 10.1298 16.9833 10.261 16.9309 10.383C16.8785 10.505 16.8023 10.6153 16.7068 10.7076L12.7068 14.7076C12.5193 14.895 12.265 15.0004 11.9998 15.0004C11.7346 15.0004 11.4803 14.895 11.2928 14.7076L7.29279 10.7076C7.10532 10.52 7 10.2657 7 10.0006C7 9.73541 7.10532 9.4811 7.29279 9.29357Z",
  fill: "#A7B2CD"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgChevronDownDisabled);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/chevron-down-disabled.d73eec78dd50d68c6d690088346c5a94.svg";